import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BuildingType } from '../../data';

@Component({
    selector: '[app-base]',
    templateUrl: './base.component.html',
    styleUrl: './base.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BaseComponent {
  public type = input<BuildingType>();
  public height = input<number>();
  public buildingType = BuildingType;
}
